export const isModalOpen = (state, id) => state.modal.openModal[id];
export const getModalData = (state, id) => {
  return state.modal.modalData[id];
};
